export default "/backend/static/media/blue.3b4d2137.png";